import PresetService from '@/api/admin/preset.service'

export default {
  state: {
    wrapper: {},
    defaultPreset: {},
  },
  getters: {
    getPresets: state => state.wrapper,
    getDefaultPreset: state => state.wrapper.presets[0],
  },
  actions: {
    async getPresets({ commit }) {
      const wrapper = await PresetService.getPresets()
      commit('SET_PRESETS', wrapper)
      commit('SET_DEFAULT_PRESETS', wrapper.presets[0])
    },
  },
  mutations: {
    SET_PRESETS(state, wrapper) {
      state.wrapper = wrapper
    },
    SET_DEFAULT_PRESETS(state, preset) {
      state.defaultPreset = preset
    },
  },
}
